module.exports = __webpack_public_path__ + "static/img/logo_c.da17ede.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo_c.png
// module id = YcKD
// module chunks = 3